import p5 from "p5";
import { genTokenData, Random } from "./genkitart/src/utils/helpers";
import {
  exportHighResImage,
  CanvasStore,
} from "./genkitart/src/utils/canvasSet";

//import { hexToHSB } from "genkitart/src/utils/colorFunctions";
//import { adjustBrightness } from "genkitart/src/utils/adjustBrightness";
//import { palettes } from "genkitart/src/utils/palletes";
//import { palette } from "spectral.js";

let tokenData = genTokenData(123);
let hash = tokenData.hash;
//const maxWidth = window.innerWidth;
//const maxHeight = window.innerHeight;
const maxWidth = document.getElementById("artCanvas").offsetWidth;
const maxHeight = document.getElementById("artCanvas").offsetHeight;
console.log("tokenData:", tokenData);
let canvasStore = new CanvasStore({
  scaleOutput: 1,
  aspectRatio: 3 / 4,
  maxHeight: maxHeight,
  maxWidth: maxWidth,
});

const sketch = (p) => {
  const { canvasDimensions } = canvasStore; // Decontruct class for all the project variables
  const bars = 7;
  const elements = 7;
  let domains;
  const palettes = [
    {
      name: "Jungle",
      colors: [
        //"#a7d4e4",
        "#E6603C",
        "#044F59",
        "#EDA034",
        "#28614C",
      ],
      stroke: "#2E3138",
      background: "#E6DECF",
    },
    {
      name: "Toys",
      colors: [
        "#E57E7F",
        "#4A4041",
        "#2C547D",
        "#C75454",
        "#EBB95B",
        "#EBA421",
        "#4D6785",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Cool",
      //Make blue colors more prevalent
      colors: [
        "#F2C64B",
        "#5A4543",
        "#305F8B",
        "#7FA9C1",
        "#305F8B",
        "#7FA9C1",
        "#305F8B",
        "#7FA9C1",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "warm",
      //This one needs callibration
      colors: [
        "#D94434",
        "#E36639",
        "#D94434",
        "#E36639",
        "#D94434",
        "#E36639",
        "#E08743",
        "#F7AC3E",
        "#EDBA3B",
        "#7FA9C1",
        "#305F8B",
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "warm2",
      primaryColors: [
        { color: "#E36639", weight: 0.5 },
        { color: "#F7AC3E", weight: 0.5 },
      ],
      secondaryColors: [
        { color: "#D94434", weight: 0.3 },
        { color: "#E08743", weight: 0.3 },
      ],
      accentColors: [
        { color: "#305F8B", weight: 0.2 },
        { color: "#7FA9C1", weight: 0.2 },
      ],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
    {
      name: "Jungle",
      primaryColors: [
        { color: "#EDA034", weight: 0.5 },
        { color: "#E6603C", weight: 0.3 },
      ],
      secondaryColors: [{ color: "#28614C", weight: 0.3 }],
      accentColors: [{ color: "#044F59", weight: 0.2 }],
      stroke: "#2E3138",
      background: "#EDE5D7",
    },
  ];

  p.setup = () => {
    let my_Canvas = p.createCanvas(p.windowWidth, p.windowHeight);
    my_Canvas.parent("artCanvas");
    p.colorMode(p.HSB, 360, 100, 100, 100);
    //Initialize the domiains
    domains = calculateDomains(bars, elements);
  };
  let time = 0; // Define this in the outer scope of your sketch
  p.draw = () => {
    let minDimension = p.min(p.width, p.height);
    let M = minDimension / 1000;
    const { renderRatio } = canvasStore;
    let R = new Random(tokenData);
    let pal = palettes[0];
    let saturation = 70;
    console.log("renderRatio", renderRatio);
    // p.background("#E6DECF");

    p.background("#EDE8DC");
    p.stroke(pal.stroke);

    for (let domain of domains) {
      for (let element of domain.elements) {
        // Calculate the midpoint of the operational zone
        let midPointY = p.lerp(
          p.lerp(domain.startY, domain.endY, element.range1.rangeStart),
          p.lerp(domain.startY, domain.endY, element.range1.rangeEnd),
          0.5 // Midpoint between start and end
        );

        // Draw a line at the midpoint
        // p.stroke("#044F59"); // Red color for clarity
        // p.line(0, midPointY, p.width, midPointY); // Line for the midpoint of the operational zone

        // Example to draw the element (adjust based on your needs)
        let elementY = p.lerp(
          domain.startY,
          domain.endY,
          element.elementStartY
        );
        p.fill("#044F59");
        // p.noStroke();
        // p.rect(domain.startX, elementY, domain.endX - domain.startX, 5); // Example rectangle for the element
      }
    }

    //visaualize the domains
    for (let domain of domains) {
      //  p.rect(domain.startX, domain.startY, domain.endX, domain.endY);

      // Draw elements within the domain
      for (let element of domain.elements) {
        // Use lerp to interpolate yStart to an actual yPos within domain's startY to endY
        // Calculate noise-based Y position
        // Calculate noise-based Y position with phase offset
        let noiseValue =
          p.noise(time + element.phaseOffset) *
            (element.range1.rangeEnd - element.range1.rangeStart) +
          element.range1.rangeStart;
        let yPos = p.lerp(domain.startY, domain.endY, noiseValue);
        // Oscillation for elementEndY
        let noiseValueEnd =
          p.noise(time + element.phaseOffset2) *
            (element.range2.rangeEnd - element.range2.rangeStart) +
          element.range2.rangeStart;
        let yPos2 = p.lerp(domain.startY, domain.endY, noiseValueEnd);
        // Increment the noiseOffset slightly for the next frame
        element.noiseOffset += 0.05; // Adjust this value to control the speed of the oscillation
        // let yPostatic = p.lerp(
        //   domain.startY,
        //   domain.endY,
        //   element.elementStartY
        // );
        // let yPos2 = p.lerp(domain.startY, domain.endY, element.elementEndY);
        // let range1Start = p.lerp(
        //   domain.startY,
        //   domain.endY,
        //   element.elementStartY - element.range1.rangeStart
        // );
        //Drawing the element at yPos

        p.fill(element.color); // Use the stored color
        p.noStroke();
        p.beginShape();
        p.vertex(domain.startX, yPos - 25 * M);
        p.vertex(domain.endX, yPos2 - 25 * M);
        p.vertex(domain.endX, yPos2 + 25 * M);
        p.vertex(domain.startX, yPos + 25 * M);
        p.endShape(p.CLOSE);
        // p.fill("blue");
        // p.ellipse(domain.startX, yPostatic + range1Start, 10 * M, 10 * M);
        // p.fill("green");
        // p.ellipse(domain.startX, yPostatic - range1Start, 10 * M, 10 * M);
      }
    }
    // Inside your draw function, increment time
    time += 0.001; // Adjust this value based on desired speed of overall movement
  };
  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
    updateDomainSizes(); // Update domain dimensions without changing element positions
  };
  p.keyReleased = (event) => {
    if (event.key === "e" || event.key === "E") {
      // Call the exportHighResImage() function with a desired pixel width
      exportHighResImage(24, 300, p, canvasStore);
    }
  };

  function calculateElementsWithOverlap(canvasHeight, numberOfElements) {
    let elements = [];
    let domainHeight = canvasHeight / numberOfElements; // Height of each central domain
    let overlapHeight = domainHeight / 2; // Define how far into adjacent domains an element can extend

    for (let i = 0; i < numberOfElements; i++) {
      // Calculate the central point of each domain
      let domainCenter = i * domainHeight + domainHeight / 2;
      // Define the range in which the element can be placed
      let minPlacement = Math.max(0, domainCenter - overlapHeight);
      let maxPlacement = Math.min(canvasHeight, domainCenter + overlapHeight);

      // Choose a random position within this range
      let elementPosition = p.random(minPlacement, maxPlacement);

      // Normalize this position if needed or use directly for placement
      elements.push({
        position: elementPosition,
        // Other properties like color, phase offset, etc., can be added here
      });
    }

    return elements;
  }
  function calculateDomains(bars, elementsPerDomain) {
    let pal = palettes[3];
    let domains = [];
    let barWidth = p.width / bars; // Calculate the width of each segment
    let noiseOffset = p.random(1000);
    let totalHeight = p.height;

    for (let i = 0; i < bars; i++) {
      let startX = i * barWidth;
      let endX = startX + barWidth;
      let elements = [];

      // Define the vertical segment for each element
      let segmentHeight = 1 / elementsPerDomain; // Normalize segment height

      for (let j = 0; j < elementsPerDomain; j++) {
        let colorIndex = p.floor(p.random(pal.colors.length));
        let elementColor = pal.colors[colorIndex];

        let phaseOffset = p.random(0, 100);
        let phaseOffset2 = p.random(0, 100);
        let baseStartY = j * segmentHeight; // Base start Y for even distribution
        let overlap = segmentHeight * 0.5; // Define overlap as half of the segment height

        // Adjusted elementStartY to allow for overlap
        let elementStartY = p.random(
          Math.max(0, baseStartY - overlap), // Ensure it doesn't go below 0
          Math.min(1, baseStartY + overlap + segmentHeight) // Ensure it doesn't go above 1
        );

        let range = p.random(0.01, 0.2);
        let range2 = p.random(0.05, 0.05);
        let elementEndY = elementStartY + p.random(-0.05, 0.05); // Ensure elementEndY is close to elementStartY but allows for some variability

        elements.push({
          elementStartY: elementStartY,
          elementEndY: elementEndY,
          noiseOffset: noiseOffset,
          phaseOffset: phaseOffset,
          phaseOffset2: phaseOffset2,
          color: elementColor,
          range1: {
            rangeStart: elementStartY - range,
            rangeEnd: elementStartY + range,
          },
          range2: {
            rangeStart: elementEndY - range2,
            rangeEnd: elementEndY + range2,
          },
        });
      }

      domains.push({
        startX: startX,
        endX: endX,
        startY: 0,
        endY: totalHeight,
        elements: elements,
      });
    }
    return domains;
  }
  // function calculateDomains(bars, elementsPerDomain) {
  //   let pal = palettes[1]; // Assuming the third palette is selected
  //   let domains = [];
  //   let barWidth = p.width / bars; // Calculate the width of each segment
  //   let totalHeight = p.height;

  //   for (let i = 0; i < bars; i++) {
  //     let startX = i * barWidth;
  //     let endX = startX + barWidth;
  //     let elements = [];

  //     // Generate Start elements for domain with equidistant spacing
  //     for (let j = 0; j < elementsPerDomain; j++) {
  //       let colorIndex = p.floor(p.random(pal.colors.length));
  //       let elementColor = pal.colors[colorIndex]; // Assign a color from the palette

  //       // Calculate equidistant positions
  //       let elementStartY = (j + 0.5) / elementsPerDomain; // Midpoint of each segment

  //       let range = 0.05; // Small range for slight variability, if needed
  //       let range2 = 0.05;
  //       let elementEndY = elementStartY; // Start and end the same for equidistant setup

  //       elements.push({
  //         elementStartY: elementStartY,
  //         elementEndY: elementEndY,
  //         color: elementColor,
  //         range1: {
  //           rangeStart: elementStartY - range,
  //           rangeEnd: elementStartY + range,
  //         },
  //         range2: {
  //           rangeStart: elementEndY - range2,
  //           rangeEnd: elementEndY + range2,
  //         },
  //         phaseOffset: p.random(0, 100), // Random phase offset for noise
  //         phaseOffset2: p.random(0, 100),
  //       });
  //     }

  //     domains.push({
  //       startX: startX,
  //       endX: endX,
  //       startY: 0,
  //       endY: totalHeight,
  //       elements: elements,
  //     });
  //   }
  //   return domains;
  // }

  function updateDomainSizes() {
    let barWidth = p.width / bars; // Calculate the new width of each segment
    for (let i = 0; i < domains.length; i++) {
      domains[i].startX = i * barWidth;
      domains[i].endX = (i + 1) * barWidth;
      domains[i].startY = 0; // Assuming startY remains at 0
      domains[i].endY = p.height; // Adjust endY to the new canvas height
      // Note: No need to adjust elementStartY or elementEndY here
    }
  }
};

new p5(sketch);
